import React, { useState, useEffect } from "react";
import { useData } from "../util/dataProvider";
import { useParams, useNavigate, Link } from "react-router-dom";
import useImageUrl from "./Image";
import Close from "../images/close.svg";
import { storage } from "../util/firebase";
import unternehmen_placeholder from '../images/unternehmen_placeholder.jpg';
import startup_placeholder from '../images/startup_placeholder.jpg';
import forschung_placeholder from '../images/forschung_placeholder.jpg';
import user_placeholder from '../images/user_placeholder.png';

export default function Company() {
    const {
        unternehmen,
        getColor,
        getCatLabel,
        assetUrl,
        experten,
    } = useData();
    const { companyid } = useParams();
    const sc = unternehmen.find((unternehmen) => unternehmen.id === companyid);
    const profilePic = useImageUrl(sc?.contact?.image);
    const headerPic = useImageUrl(sc?.header);
    const logo = useImageUrl(sc?.logo);
    const navigate = useNavigate();

    const [logoUrl, setLogoUrl] = useState([]);
     console.log(unternehmen)
    function getbild(length, i, array) {
        if (sc.contact[i].image) {
            storage
                .ref(sc.contact[i].image)
                .getDownloadURL()
                .then((url) => {
                    array[i] = url;
                    i = i + 1;
                    if (i < length) {
                        getbild(length, i, array);
                    } else {
                        setLogoUrl(array);
                    }
                });
        } else if (i < length) {
            i = i + 1;
            getbild(length, i, array);
        }
    }

    const placeholderPic=(cat)=>{
        switch(cat){
                case 'unternehmen': return unternehmen_placeholder; break;
                case 'startup': return startup_placeholder; break;
                case 'forschung': return forschung_placeholder; break;
                default: return unternehmen_placeholder; break;

        }
    }

    useEffect(() => {
        let array = [];
        let i = 0;
        if (sc && sc.contact instanceof Array) {
            if (sc.contact.length > 0) {
                getbild(sc.contact.length, i, array);
            }
        }
    }, [sc?.contact]);

    useEffect(() => {
        let menu = document.getElementById("hamburger");
        if (menu) {
            menu.style.opacity = "0";
        }
    }, []);
    if (!sc) {
        return <div>Das Unternehmen konnte nicht gefunden werden.</div>;
    }

    return (
        <div className='single-company'>
            <img
                className='close'
                src={assetUrl + Close}
                onClick={() => navigate("/")}
            />{" "}
           <div
                className='header-image'
                style={{
                    backgroundImage: headerPic
                        ? `url(${headerPic})`
                        : `url(${assetUrl+placeholderPic(unternehmen.category)})`,
                }}></div>
            <div
                className='header-information'
                style={{ backgroundColor: getColor(sc.category) }}>
                <div className='left'>
                    <div className='cat'>{getCatLabel(sc.category)}</div>
                    <div className='name'>{sc.name}</div>
                    <a
                        href={sc.website}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='website'>
                        {sc.website
                            .replace("https://", "")
                            .replace("http://", "")}
                    </a>
                </div>
                <div className='right'>
                    <h3>short story</h3>
                    <div className='desc'>{sc.description}</div>
                </div>
            </div>
            <div className='focus-block'>
                {logo && <img src={logo} alt='Logo' className='logo' />}
              
            </div>
            <div className='additional-information'>
                <div className='left'>
                    <h3>Unternehmen</h3>
                    <p>
                        {sc.name}
                        <br />
                        {sc.street_number}
                        <br />
                        {sc.zip} {sc.city}
                        <br />
                    </p>
                    <p>
                        Tel: {sc.phone}
                        <br />
                        {sc.email}
                    </p>{" "}
                    <p>
                       {sc.founding &&  `Gründungsjahr: ${sc.founding}`}
                        <br />
                        {sc.employees && `Mitarbeiter*innen: ${sc.employees}`}
                    </p>{" "}
                </div>
                <div className='right'>
                    <h3 className='margin-bottom-light'> Schwerpunkte</h3>
                    {sc.fields &&
                        sc.fields.map((field, idx) => {
                            return <div key={idx}>/ {field}</div>;
                        })}
                    <h3 className='margin-top-light margin-bottom-light'>
                        Interesse an
                    </h3>
                    {sc.interested &&
                        sc.interested.map((interest, idx) => {
                            return <div key={idx}>/ {interest}</div>;
                        })}
                </div>
            </div>
            <div className='partner-container'>
            {sc && sc.contact instanceof Array && <h3 className='margin-top'>Ansprechpartner*in</h3>}
                <div
                    style={{
                        width: "100%",
                        display: "grid",
                        gridTemplateColumns:
                            "repeat(auto-fit,minmax(375px,1fr))",
                        gridGap: "64px",
                    }}>
                    {sc &&
                        sc.contact instanceof Array &&
                        sc.contact.map((partner, index) => {
                            let idx = experten.findIndex(
                                (ele) => ele.user_email === partner.email
                            );

                            return (
                                <div className='partner'>
                                    {logoUrl[index] ? (
                                        <img
                                            src={logoUrl[index]}
                                            className='profilepic'
                                        />):
                                       ( <img
                                        src={assetUrl+user_placeholder}
                                        className='profilepic'
                                    />
                                    )}
                                    <p style={{ fontWeight: 300 }}>
                                        <strong>{partner.name}</strong>
                                        <br />
                                        {partner.position}
                                        <br />
                                        <a
                                            style={{
                                                color: getColor(sc.category),
                                            }}
                                            href={`mailto:${partner.mail}`}>
                                            {partner.email}
                                        </a>
                                        <br />
                                        {partner.phone}
                                    </p>
                                    {idx >= 0 && (
                                        <Link
                                            to={`/expert/${experten[idx].id}`}>
                                            <div
                                                style={{
                                                    color: "rgb(227, 63, 18)",
                                                }}>
                                                Zum Profil
                                            </div>
                                        </Link>
                                    )}
                                </div>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}
